import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/close.svg'
import _imports_1 from '@/assets/icons/svg/speaker-off.svg'
import _imports_2 from '@/assets/icons/svg/speaker.svg'
import _imports_3 from '@/assets/omar/OMAR-GLAD.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a52e07b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-full h-full" }
const _hoisted_2 = { class: "flex flex-row absolute z-10 bottom-5 w-full justify-end pr-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_4 = {
  key: 1,
  class: "w-full h-full relative"
}
const _hoisted_5 = {
  key: 0,
  class: "absolute left-0 top-1/2 transform -translate-y-1/2 z-10"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "text-white text-lg md:text-5xl font-black p-8 md:p-16" }
const _hoisted_10 = { class: "relative text-left" }
const _hoisted_11 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_12 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_2,
  alt: "close"
}
const _hoisted_13 = {
  key: 0,
  class: "text-black text-2xl p-4 break-normal"
}
const _hoisted_14 = {
  key: 1,
  class: "text-black text-2xl m-4"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 2,
  class: "mt-16 flex flex-col"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-2xl m-4" }, "Prøverunde", -1 /* HOISTED */))
const _hoisted_18 = { class: "relative inline-block" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-56",
  style: {"height":"20rem"},
  src: _imports_3,
  alt: "instructions - happy omar image"
}, null, -1 /* HOISTED */))
const _hoisted_20 = { class: "flex flex-row justify-center mt-4" }
const _hoisted_21 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_22 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_2,
  alt: "close"
}
const _hoisted_23 = {
  key: 1,
  class: "absolute w-full h-full left-0 top-0 pointer-events-none"
}
const _hoisted_24 = { class: "absolute w-full h-full flex flex-row place-items-center justify-center" }
const _hoisted_25 = { class: "w-40 h-40 relative" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 0,
  class: "flex flex-row absolute z-10 bottom-5 w-full justify-end pr-44 pointer-events-auto"
}
const _hoisted_29 = {
  key: 1,
  class: "flex flex-row absolute z-10 bottom-5 w-full justify-end pr-44 pointer-events-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.quizzDone)
      ? (_openBlock(), _createBlock($setup["Celebrate"], {
          key: 0,
          class: "w-full h-full",
          mode: $setup.quizzDoneMode,
          "conclusion-audio": $setup.currentSentence?.conclusionAudio || ''
        }, {
          finish: _withCtx(() => [
            _createVNode($setup["Button"], {
              class: "absolute top-8 right-8 pointer-events-auto ml-6 bg-white m-6",
              childclass: 'w-12 h-12',
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('finish')))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1 /* STABLE */
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createCommentVNode("Button class=\"pointer-events-auto bg-white mr-4\" :childclass=\"'w-12 h-12'\" @click=\"startRound(true)\">\n          <img class=\"w-4 h-4\" src=\"@/assets/icons/svg/replay.svg\" alt=\"close\" />\n        </Button"),
              _createVNode($setup["Button"], {
                backgroundcolour: 'bg-sl-green-button',
                textcolour: 'text-white',
                childclass: 'text-2xl border-none p-3 h-12',
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.nextRound()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["mode", "conclusion-audio"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createCommentVNode(" Review buttons "),
          ($setup.sentencelist.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "rounded-r-4xl p-3 pr-5 mt-2 h-16 w-16 flex flex-row justify-end",
                  style: {"background-color":"#d9eefb"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.reviewState('placeReview')))
                }, [
                  _createElementVNode("img", {
                    src: $setup.placement,
                    class: "w-4"
                  }, null, 8 /* PROPS */, _hoisted_6)
                ]),
                _createElementVNode("div", {
                  class: "rounded-r-4xl p-3 pr-5 mt-2 h-16 w-16 flex flex-row justify-end",
                  style: {"background-color":"#d9eefb"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.reviewState('instructionReview')))
                }, [
                  _createElementVNode("img", {
                    src: $setup.instructions,
                    class: "w-6"
                  }, null, 8 /* PROPS */, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: "absolute left-0 top-0 flex flex-row justify-center items-center w-full h-full text-center text-white overflow-hidden",
            style: _normalizeStyle([{ backgroundColor: $setup.sentencelist.length > 0 ? '#b3e9ff' : '#1e56b6' }])
          }, [
            _createCommentVNode(" Text bubble "),
            ($setup.sentencelist.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "absolute z-10 pointer-events-none bg-left bg-no-repeat bg-fill p-6 top-2 left-1/2 transform -translate-x-1/2",
                  style: _normalizeStyle([{"top":"10%"}, { backgroundImage: 'url(' + $setup.bgTextImageBlue + ')' }])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.question.word), 1 /* TEXT */)
                  ])
                ], 4 /* STYLE */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Teacher guidance "),
            ($setup.sentencelist.length > 0 && ($setup.showAdvice || $setup.showSentence))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "absolute z-10 pointer-events-none bg-left bg-no-repeat bg-fill p-6 xl:p-20 bottom-24 left-1/2 transform -translate-x-1/2",
                  style: _normalizeStyle({ backgroundImage: 'url(' + $setup.bgTextImage + ')' })
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createCommentVNode(" Sound replay button "),
                    _createVNode($setup["Button"], {
                      class: "absolute pointer-events-auto bg-white p-2 rounded-full -top-6 xl:-top-20 -right-10",
                      childclass: 'w-12 h-12',
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.soundIsPlaying ? $setup.stopSounds() : $setup.playSentence()))
                    }, {
                      default: _withCtx(() => [
                        ($setup.soundIsPlaying)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                          : (_openBlock(), _createElementBlock("img", _hoisted_12))
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_Transition, {
                      mode: "out-in",
                      name: "fade"
                    }, {
                      default: _withCtx(() => [
                        ($setup.showAdvice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.adviceText), 1 /* TEXT */))
                          : ($setup.currentSentence && $setup.showSentence)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("p", {
                                  class: "text text-center break-normal",
                                  innerHTML: $setup.currentSentence.sentence
                                }, null, 8 /* PROPS */, _hoisted_15)
                              ]))
                            : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createCommentVNode("div v-if=\"showAdvice\" class=\"absolute -top-20 xl:-top-32 -left-8 w-full\">\n              <div class=\"relative flex flex-row items-center\">\n                <img :src=\"lightBulb\" class=\"z-10 w-16\" alt=\"light bulb - word focus\" />\n                <div class=\"rounded-r-full p-3 text-center flex flex-col justify-center h-12 -m-6 -mt-2 pl-8 pr-6\" style=\"background-color: #48b6ff\">\n                  <p class=\"uppercase font-bold\">{{ t(bulbText) }}</p>\n                </div>\n              </div>\n            </div")
                  ])
                ], 4 /* STYLE */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Avatars "),
            _createCommentVNode("template v-if=\"sentencelist.length > 0\">\n          <div v-if=\"players.length >= 1 && balls[0]\" class=\"absolute top-8 left-12 transform rotate-135\">\n            <QuizzControl :player=\"players[0]\"> </QuizzControl>\n          </div>\n          <div v-if=\"players.length >= 3 && balls[2]\" class=\"absolute bottom-8 left-12 transform rotate-45\">\n            <QuizzControl :player=\"players[2]\"> </QuizzControl>\n          </div>\n          <div v-if=\"players.length >= 4 && balls[3]\" class=\"absolute top-8 right-12 transform -rotate-135 z-30\">\n            <QuizzControl :player=\"players[3]\"> </QuizzControl>\n          </div>\n          <div v-if=\"players.length >= 2 && balls[1]\" class=\"absolute bottom-8 right-12 transform -rotate-45\">\n            <QuizzControl :player=\"players[1]\"> </QuizzControl>\n          </div>\n        </template"),
            _createCommentVNode(" Instruction area for Carousel and Review "),
            ($setup.sentencelist.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _renderSlot(_ctx.$slots, "pagination", {}, undefined, true),
                    _createElementVNode("div", _hoisted_20, [
                      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                    ]),
                    _createVNode($setup["Button"], {
                      class: "absolute pointer-events-auto bg-white p-2 rounded-full",
                      style: {"top":"1rem","right":"1rem"},
                      childclass: 'w-12 h-12',
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.soundIsPlaying ? $setup.stopSounds() : _ctx.$emit('playsound')))
                    }, {
                      default: _withCtx(() => [
                        ($setup.soundIsPlaying)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                          : (_openBlock(), _createElementBlock("img", _hoisted_22))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("div v-if=\"players.length >= 3\" class=\"absolute bottom-8 left-12 transform rotate-45\">\n      <QuizzControl :player=\"players[2]\" @yes=\"clickAnswer('2', Thumbs.up)\" @no=\"clickAnswer('2', Thumbs.down)\">\n        <div ref=\"ballP2\" class=\"rounded-full w-36 h-36\"></div>\n      </QuizzControl>\n      </div>\n      <div v-if=\"players.length >= 4\" class=\"absolute top-8 right-12 transform -rotate-135 z-30\">\n        <QuizzControl :player=\"players[3]\" @yes=\"clickAnswer('3', Thumbs.up)\" @no=\"clickAnswer('3', Thumbs.down)\"\n          ><div ref=\"ballP2\" class=\"rounded-full w-36 h-36\"></div>\n        </QuizzControl>\n      </div>\n      <div v-if=\"players.length >= 2\" class=\"absolute bottom-8 right-12 transform -rotate-45\">\n        <QuizzControl :player=\"players[1]\" @yes=\"clickAnswer('1', Thumbs.up)\" @no=\"clickAnswer('1', Thumbs.down)\"\n          ><div ref=\"ballP2\" class=\"rounded-full w-36 h-36\"></div>\n        </QuizzControl>\n      </div")
          ], 4 /* STYLE */),
          ($setup.sentencelist.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createCommentVNode(" Omar's circles "),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", {
                    ref: "finalBall0",
                    class: "rounded-full w-32 h-32",
                    style: _normalizeStyle({ backgroundColor: $setup.balls[0] && $setup.balls[0].status.sunk ? '#b3e9ff' : '#e0dfe0' })
                  }, null, 4 /* STYLE */),
                  _createElementVNode("div", {
                    ref: "finalBall1",
                    class: "rounded-full w-32 h-32",
                    style: _normalizeStyle({ backgroundColor: $setup.balls[1] && $setup.balls[1].status.sunk ? '#b3e9ff' : '#e0dfe0' })
                  }, null, 4 /* STYLE */),
                  _createElementVNode("div", {
                    ref: "finalBall2",
                    class: "rounded-full w-32 h-32",
                    style: _normalizeStyle({ backgroundColor: $setup.balls[2] && $setup.balls[2].status.sunk ? '#b3e9ff' : '#e0dfe0' })
                  }, null, 4 /* STYLE */),
                  _createElementVNode("div", {
                    ref: "finalBall3",
                    class: "rounded-full w-32 h-32",
                    style: _normalizeStyle({ backgroundColor: $setup.balls[3] && $setup.balls[3].status.sunk ? '#b3e9ff' : '#e0dfe0' })
                  }, null, 4 /* STYLE */),
                  _createElementVNode("div", _hoisted_25, [
                    (!$setup.areYouSure)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "w-32 h-32",
                          src: $setup.omarSpeaksImage,
                          alt: "intoduction main image"
                        }, null, 8 /* PROPS */, _hoisted_26))
                      : _createCommentVNode("v-if", true),
                    ($setup.areYouSure)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "w-40 h-40 absolute",
                          src: $setup.listenAgainImage,
                          alt: "intoduction main image"
                        }, null, 8 /* PROPS */, _hoisted_27))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createCommentVNode(" Comfirm complete this round "),
                ($setup.awaitingNext)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode($setup["Button"], {
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none p-3 h-12',
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.confirmEndRound()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('next')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Comfirm 'tip' "),
                ($setup.awaitingTipNext)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode($setup["Button"], {
                        backgroundcolour: 'bg-sl-green-button',
                        textcolour: 'text-white',
                        childclass: 'text-2xl border-none p-3 h-12',
                        onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.confirmTip()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('continue')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(["absolute w-full h-full left-0 top-0 pointer-events-none", $setup.bounceAgain > 0 ? 'animate-bounce' : ''])
          }, [
            ($setup.players.length >= 1 && $setup.balls[0])
              ? (_openBlock(), _createBlock(_component_Draggable, {
                  key: 0,
                  bounds: "body",
                  position: $setup.balls[0].position,
                  class: "absolute drag-item pointer-events-auto",
                  onStart: _cache[8] || (_cache[8] = (e) => $setup.onStart(e, $setup.balls[0])),
                  onStop: _cache[9] || (_cache[9] = (e) => $setup.onStop(e, $setup.balls[0]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex flex-row justify-center rounded-full z-10 w-32 h-32",
                      style: _normalizeStyle({ backgroundColor: $setup.players[0].profile.avatar.backgroundColour || '#aaaaaa' })
                    }, null, 4 /* STYLE */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["position"]))
              : _createCommentVNode("v-if", true),
            ($setup.players.length >= 2 && $setup.balls[1])
              ? (_openBlock(), _createBlock(_component_Draggable, {
                  key: 1,
                  bounds: "body",
                  position: $setup.balls[1].position,
                  class: "absolute drag-item pointer-events-auto",
                  onStart: _cache[10] || (_cache[10] = (e) => $setup.onStart(e, $setup.balls[1])),
                  onStop: _cache[11] || (_cache[11] = (e) => $setup.onStop(e, $setup.balls[1]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex flex-row justify-center rounded-full z-10 w-32 h-32",
                      style: _normalizeStyle({ backgroundColor: $setup.players[1].profile.avatar.backgroundColour || '#aaaaaa' })
                    }, null, 4 /* STYLE */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["position"]))
              : _createCommentVNode("v-if", true),
            ($setup.players.length >= 3 && $setup.balls[2])
              ? (_openBlock(), _createBlock(_component_Draggable, {
                  key: 2,
                  bounds: "body",
                  position: $setup.balls[2].position,
                  class: "absolute drag-item pointer-events-auto",
                  onStart: _cache[12] || (_cache[12] = (e) => $setup.onStart(e, $setup.balls[2])),
                  onStop: _cache[13] || (_cache[13] = (e) => $setup.onStop(e, $setup.balls[2]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex flex-row justify-center rounded-full z-10 w-32 h-32",
                      style: _normalizeStyle({ backgroundColor: $setup.players[2].profile.avatar.backgroundColour || '#aaaaaa' })
                    }, null, 4 /* STYLE */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["position"]))
              : _createCommentVNode("v-if", true),
            ($setup.players.length >= 4 && $setup.balls[3])
              ? (_openBlock(), _createBlock(_component_Draggable, {
                  key: 3,
                  bounds: "body",
                  position: $setup.balls[3].position,
                  class: "absolute drag-item z-50 pointer-events-auto",
                  onStart: _cache[14] || (_cache[14] = (e) => $setup.onStart(e, $setup.balls[3])),
                  onStop: _cache[15] || (_cache[15] = (e) => $setup.onStop(e, $setup.balls[3]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "flex flex-row justify-center rounded-full z-10 w-32 h-32",
                      style: _normalizeStyle({ backgroundColor: $setup.players[3].profile.avatar.backgroundColour || '#aaaaaa' })
                    }, null, 4 /* STYLE */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["position"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]))
  ]))
}